export enum FileType {
  Recording = 'Recording',
}
